import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ScrollService } from '../../scrolls/service/scroll.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import zoomPlugin from 'chartjs-plugin-zoom';
import { GraphicActionInterface } from '../../../../../utils/models/common.interface';
import { BarWithErrorBarsController, BarWithErrorBar } from 'chartjs-chart-error-bars';
import { GraphicActionsComponent } from '../../../../../public-api';


@Component({
  selector: 'chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.scss']
})

export class ChartComponent implements OnInit, AfterViewInit {
  @ViewChild('GraphicActionsChild') actionChild: GraphicActionsComponent;
  @ViewChild('graphicChart', { static: true }) readonly graphicChart: any;
  @ViewChild('graphicChart2', { static: true }) readonly graphicChart2: any;
  @ViewChild('graphicChart3', { static: true }) readonly graphicChart3: any;

  @ViewChild('chartContainer') chartContainer: ElementRef;

  @Input() typeGraphic: any = 'line';
  @Input() datasets: any = [];
  @Input() options: any = {};
  @Input() label: any = [];
  @Input() haveScroll = false;
  @Input() simple = true;
  @Input() haveTwoAxis = false;
  @Input() scrollOnTop = false;
  @Input() axisYCTXWidth = 45;
  @Input() axisY1CTXWidth = 45;
  @Input() load = 0;
  @Input() chartDataLabels: boolean;
  @Input() actions: GraphicActionInterface;
  @Input() drawRiskBar = null;
  @Input() plugin = null;
  @Input() chartId = 'graphicChart';
  @Input() width = null;
  @Input() titleY = null

  @Input() height = '500px'

  chartMod: any;
  chartHaveScroll: any;
  yAxis = 0;
  xAxis = 0;
  dragmodeChart = false
  private readonly unsubscribeAll: Subject<any[]> = new Subject();

  constructor(
    private readonly scrollService: ScrollService
  ) {
    const viewportHeight = window.innerHeight;
    if (viewportHeight < 850 && viewportHeight > 800) {
      this.height = '500px';
    } else if (viewportHeight < 800) {
      this.height = '400px';
    } else {
      this.height = '600px'; // Define a altura padrão
    }
  }

  ngOnInit() {
    if(!this.options.plugins?.zoom && this.actions) {
      this.zoomInitial();
    }
  }

  zoomInitial() {
    const context = this;
    this.options.plugins.zoom = {
      zoom: {
        mode: 'xy',
        onZoom({chart}) {
          const yAxis = chart.scales['y'];

          if (yAxis.min < context.yAxis) {
            chart.resetZoom();
            context.actionChild.disableAction('zoomOut', true)
          } else {
            context.actionChild.disableAction('zoomOut', false)
          }
        },
        onZoomComplete({chart}) {
          context.dragmodeChart = false;
          chart.options.plugins.zoom.zoom.drag.enabled = false; // Disable drag after zoom
          chart.update();
        },
        drag: {
          enabled: false,
          borderColor: 'rgb(51, 51, 51)',
          borderWidth: 1
        }
      }
    }
  }

  ngAfterViewInit() {
    this.actionChild?.disableAction('zoomOut', true)
    if (this.haveScroll) {
      this.chartContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
      this.scrollService.newEvent.pipe(takeUntil(this.unsubscribeAll))
        .subscribe((res) => {
          this.chartContainer.nativeElement.scrollLeft = res
        })
    }
  }

  ngOnChanges() {
    Chart.register(zoomPlugin);
    Chart.register(...registerables);
    if(this.chartDataLabels){
      Chart.register(ChartDataLabels);
    }
    Chart.register(...registerables, BarWithErrorBarsController, BarWithErrorBar);


    if (
      (this.datasets && this.datasets.length > 0) ||
      (this.load)
    ) {
      this.loadChart();
    }
  }

  loadChart() {
    if (this.chartMod instanceof Chart) {
      this.chartMod.destroy();
    }


    this.datasets.forEach((data) => {
      data.barPercentage = 0.7;
      data.categoryPercentage = 1;
    });

    this.chartMod = new Chart(this.graphicChart.nativeElement, {
      type: this.typeGraphic,
      data: {
        labels: this.label,
        datasets: this.datasets,
      },
      options: {...this.options,   maintainAspectRatio: false,},
      plugins: [
        zoomPlugin,
        ...(this.chartDataLabels ? [ChartDataLabels] : []),
        ...(this.drawRiskBar ? [this.drawRiskBar] : []), // Adiciona o plugin se necessário
        ...(this.plugin ? [this.plugin] : []),
      ],
    });

    if (this.haveScroll) {
      this.chartHaveScroll = new Chart(this.graphicChart2.nativeElement, {
        type: this.typeGraphic,
        data: {
          labels: this.label,
          datasets: this.datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              bottom: 28,
            }
          },
          scales: {
            x: {
              ticks: {
                display: false
              },
              grid: {
                drawTicks: false,
              }
            },
            y: {
              afterFit: (ctx) => {
                ctx.width = this.axisYCTXWidth;
              }
            },
            y1: {
              display: false,
            },
            xAxes: [{
              ticks: {
                padding: 20
              }
            }]
          },
          plugins: {
            legend: {
              display: false
            }
          }
        }
      });
      if (this.haveTwoAxis) {
        this.chartHaveScroll = new Chart(this.graphicChart3.nativeElement, {
          type: this.typeGraphic,
          data: {
            labels: this.label,
            datasets: this.datasets,
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                bottom: 28,
              }
            },
            scales: {
              x: {
                ticks: {
                  display: false
                },
                grid: {
                  drawTicks: false,
                }
              },
              y1: {
                afterFit: (ctx) => {
                  ctx.width = this.axisY1CTXWidth;
                }
              },
              xAxes: [{
                ticks: {
                  padding: 20
                }
              }]
            },
            plugins: {
              legend: {
                display: false
              }
            }
          }
        });
      }
    }

    this.yAxis = this.chartMod.scales['y']?.min
    this.xAxis = this.chartMod.scales['x']?.min
  }

  onScroll(event: Event) {
    const scrollPosition = (event.target as HTMLElement).scrollLeft
    this.scrollService.emitScroll(scrollPosition)
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  graphicActions(event) {
    this.dragmodeChart = false;
    if(event === 'zoomIn') {
      this.chartMod.zoom(1.12)
      this.actionChild.disableAction('zoomOut', false)
      if (this.options.plugins?.zoom) {
        this.options.plugins.zoom.pan = {
          enabled: true,
          mode: 'xy',
        };
      }
      this.chartMod.update();
    } else if(event === 'zoomOut') {
      this.chartMod.zoom(0.9);
      if (this.options.plugins?.zoom) {
        this.options.plugins.zoom.pan = {
          enabled: true,
          mode: 'xy',
        };
        this.chartMod.update();
      }
    } else if(event === 'refresh') {
      this.chartMod.resetZoom();
      this.actionChild.disableAction('zoomOut', true)
      if (this.options.plugins?.zoom) {
        this.options.plugins.zoom.pan = {};
      }
      this.chartMod.update();
    } else {
      this.dragmodeChart = true;
      this.options.plugins.zoom.zoom.drag.enabled = true;
      this.options.plugins.zoom.pan = {};
      this.chartMod.update('none');
    }
  }

}
